<template>
  <div :class="isPopup ? 'sticky-top-right-popup' : 'sticky-top-right'">
    <div class="d-flex justify-content-end mb-3 align-items-center">
      <div v-if="!isButtonSplit" class="d-flex gap-1 flex-nowrap">
        <el-button
          v-for="(button, key) in filteredButtons"
          :key="key"
          :data-id="button.title ? button.title : 'Save'"
          :type="button.event === 'save' ? 'primary' : 'default'"
          :icon="button.event === 'save' ? 'el-icon-check' : ''"
          @click="onButtonClick(button.event, !['index', 'process'].includes(button.event))"
        >
          {{ $i18n.t(button.title ? button.title : 'Save') }}
          <spinner v-if="button.event === 'save'" :active="isSpinnerActive"></spinner>
        </el-button>
      </div>
      <el-dropdown
        v-else
        split-button
        type="primary"
        popper-class="open-dropdown"
        data-id="buttonDropdown"
        size="default"
        @click.prevent="onButtonClick(firstButton.event, true)"
      >
        <i class="el-icon-check"></i>
        {{ $i18n.t(firstButton.title ? firstButton.title : 'dynform_button_save') }}
        <spinner :active="isSpinnerActive"></spinner>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(button, key) in filteredButtons"
            :key="key"
            @click.native="onButtonClick(button.event, button.event !== 'index')"
            v-if="button.event !== 'save'"
          >
            <span :data-id="button.title">{{ $i18n.t(button.title ? button.title : 'Save') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <form-data-version-list
        v-if="formVersionsAvailable"
        id="form-data-version-list"
        :id-form="idForm"
        :id-main-table="idMainTable"
        :is-blockchain-enabled="blockchainEnabled"
        :show-version-button="showVersionButton"
        :show-copy-button="showCopyButton"
        :show-clone-button="showCloneButton"
      />
    </div>
  </div>
</template>

<script>
import Spinner from './Spinner'
import { filter, keysIn, first } from 'lodash'
import FormDataVersionList from './form-version/FormDataVersionList'

const TYPE_SUBMIT_SAVE = 'save'
const TYPE_SUBMIT_SAVE_AND_NEW = 'saveAndNew'
const TYPE_SUBMIT_SAVE_AND_CLOSE = 'saveAndClose'
const TYPE_SUBMIT_PROCESS = 'process'
const TYPE_INDEX = 'index'

export default {
  components: {
    Spinner,
    FormDataVersionList,
  },
  name: 'DynFormButtons',
  props: {
    isPopup: {
      type: Boolean,
      default: false,
    },
    isSpinnerActive: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    buttons: {
      type: Object,
      default: () => ({
        save: { event: TYPE_SUBMIT_SAVE, title: 'dynform_button_save' },
        saveAndNew: { event: TYPE_SUBMIT_SAVE_AND_NEW, title: 'dynform_button_saveAndNew' },
        saveAndClose: { event: TYPE_SUBMIT_SAVE_AND_CLOSE, title: 'dynform_button_saveAndClose' },
        close: { event: TYPE_INDEX, title: 'dynform_button_close' },
        process: { event: TYPE_SUBMIT_PROCESS, title: 'dynform_button_process' },
      }),
    },
    formVersionProps: {
      type: Object,
      default: () => ({
        idForm: null,
        idMainTable: null,
        formVersionsAvailable: false,
        blockchainEnabled: false,
        formDataVersionButtons: {
          showVersionButton: true,
          showCopyButton: false,
          showCloneButton: false,
        },
      }),
    },
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      loaded: false,
    }
  },
  computed: {
    filteredButtons() {
      let buttons
      if (this.readOnly) {
        buttons = filter(this.buttons, (item) => item.event === TYPE_INDEX)
      } else if (this.isPopup) {
        buttons = filter(this.buttons, (item) => !item.hidden && item.event !== TYPE_SUBMIT_SAVE_AND_CLOSE)
      } else {
        buttons = filter(this.buttons, function (item) {
          return !item.hidden
        })
      }
      return buttons
    },
    firstButton() {
      return this.filteredButtons[first(keysIn(this.filteredButtons))]
    },
    formVersionsAvailable() {
      return this.formVersionProps.formVersionsAvailable
    },
    idForm() {
      return this.formVersionProps.idForm
    },
    idMainTable() {
      return this.formVersionProps.idMainTable
    },
    isButtonSplit() {
      const hasMoreThanOne = Object.keys(this.buttons).length > 1
      const mediaQuery = this.isPopup ? 1350 : 1100
      return this.innerWidth < mediaQuery && hasMoreThanOne
    },
    blockchainEnabled() {
      return this.formVersionProps.blockchainEnabled
    },
    showVersionButton() {
      return this.formVersionProps.formDataVersionButtons.showVersionButton
    },
    showCopyButton() {
      return this.formVersionProps.formDataVersionButtons.showCopyButton
    },
    showCloneButton() {
      return this.formVersionProps.formDataVersionButtons.showCloneButton
    },
  },
  methods: {
    onButtonClick(event, save) {
      this.$emit('button-click', { event, save })
    },
    onResize() {
      this.innerWidth = window.innerWidth
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style scoped lang="scss">
.sticky-top-right {
  position: sticky;
  top: 65px;
  right: 0px;
  z-index: 2000;
}
.sticky-top-right-popup {
  position: sticky;
  top: 15px;
  right: 20px;
  z-index: 2000;
}
@media (min-width: 1100px) {
  .large-flex {
    display: flex !important;
  }
  .large-none {
    display: none !important;
  }
}
@media (min-width: 1350px) {
  .large-flex-popup {
    display: flex !important;
  }
  .large-none-popup {
    display: none !important;
  }
}
</style>
